import { EntityService } from "@/model/service/entity-service"
import { Company } from "@/model/entity/company/company"
import { AxiosPromise } from "axios"

export interface IDefaultStatuses {
  name: string
  value: string
}
class CompanyService extends EntityService<Company> {
  constructor() {
    super("company", Company)
  }

  getDefaultStatuses(): AxiosPromise<IDefaultStatuses[]> {
    return this.$http.get(this.path + "/statuses/")
  }

  getB2BCompanies(): AxiosPromise<Company[]> {
    return this.$http.get(this.path + "/b2b")
  }

  disableCompanyB2B(id: number): AxiosPromise<Company> {
    return this.$http.put(this.path + "/b2b/disable/" + id)
  }
}

export interface ICompanyService extends EntityService<Company> {
  getB2BCompanies(): AxiosPromise<Company[]>

  disableCompanyB2B(id: number): AxiosPromise<Company>
}

const service = new CompanyService()

export const companyService = service
